export const pickerOptions = {
    dateFormat: 'd/m/Y',
    locale: {
        rangeSeparator: ' - ',
        weekdays: {
            longhand: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
            shorthand: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
        },
    },
    mode: 'range',
};
export const isTheSameDateRange = (newDate, previousDate) => {
    const newDateFormated = newDate
        .map((date) => {
        if (!date)
            return null;
        return Date.getFormatted(date);
    })
        .filter((i) => i);
    return String(newDateFormated) === String(previousDate);
};
//# sourceMappingURL=helpers.js.map